import { TripEventEnum } from 'src/common/external/bambi-api/bambiApi';

import { eventTypeCopyMap } from './eventTypeCopyMap';
import { TripSummaryTitle } from './TripSummaryTitle';

export function TripSummaryEventType({
  eventType,
}: {
  eventType: TripEventEnum;
}) {
  return <TripSummaryTitle title={eventTypeCopyMap[eventType] || eventType} />;
}
